export default __webpack_public_path__ + "static/6-find-word-game-ba16a89e3dbac962f3e026b1d06f9cd0.jpg";